// Browser fallback values only. The backend supplies the real defaults and
// performs every score/tier calculation over PostgreSQL-backed signals.

export const SIGNAL_FAMILIES = ['INTENT', 'CAPACITY', 'ACTIVITY', 'ORG_CHANGE'];

export const FALLBACK_SATURATION_K = 0.7;

export const FALLBACK_SCORING_CONFIG = {
  weights: {
    INTENT: 30,
    CAPACITY: 35,
    ACTIVITY: 20,
    ORG_CHANGE: 15,
  },
  halfLifeDays: 30,
  corroborationMinFamilies: 2,
  corroborationBonus: 1.15,
  corroborationWindowDays: 60,
  tierAMin: 70,
  tierBMin: 40,
  saturationK: FALLBACK_SATURATION_K,
};

export const FALLBACK_SLIDER_RANGES = {
  weight: { min: 0, max: 60, step: 1 },
  halfLifeDays: { min: 7, max: 90, step: 1 },
  corroborationMinFamilies: { min: 1, max: SIGNAL_FAMILIES.length, step: 1 },
  corroborationBonus: { min: 1.0, max: 1.5, step: 0.01 },
  corroborationWindowDays: { min: 30, max: 180, step: 1 },
  tierAMin: { min: 40, max: 95, step: 1 },
  tierBMin: { min: 10, max: 65, step: 1 },
};
